export const SHOW = "linerProgress/SHOW";
export const HIDE = "linerProgress/HIDE";

export const showLinerProgress = () => ({
  type: SHOW
});

export const hideLinerProgress = () => ({
  type: HIDE
});

const initialState = {
  show: false
};

const linerProgress = (state = initialState, action) => {
  switch (action.type) {
    case SHOW:
      return { show: true };
    case HIDE:
      return { show: false };
    default:
      return state;
  }
};

export default linerProgress;



// WEBPACK FOOTER //
// ./src/redux/modules/linerProgress.js